import { createFeatureSelector, createSelector } from '@ngrx/store';
import { OrdersState } from './orders.state';

export const selectOrdersState = createFeatureSelector<OrdersState>('orders');

export const selectUserOrders = createSelector(
  selectOrdersState,
  (state) => state.orders
);

export const selectFilteredUserOrders = createSelector(
  selectUserOrders,
  (orders) => orders ? orders.filter(o => o) : []
);

export const selectUserOrdersLoading = createSelector(
  selectOrdersState,
  (state) => state.isLoading
);

export const selectUserOrdersTotalPages = createSelector(
  selectOrdersState,
  (state) => state.totalPages
);

export const selectUserOrdersCurrentPage = createSelector(
  selectOrdersState,
  (state) => state.currentPage
);
